"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5705],{

/***/ 5705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Viewed; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(917);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1463);
/* harmony import */ var _posts_post_card__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5435);
/* harmony import */ var _lib_consts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9006);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5944);



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var _ref2 =  true ? {
  name: "eznaoo",
  styles: "display:flex;align-items:center;justify-content:space-between;padding:0 0 8px"
} : 0;

var _ref3 =  true ? {
  name: "eznaoo",
  styles: "display:flex;align-items:center;justify-content:space-between;padding:0 0 8px"
} : 0;

function Viewed(_ref) {
  var _viewed$results;

  var title = _ref.title,
      viewed = _ref.viewed;
  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.u)();

  if (viewed === undefined || !(viewed !== null && viewed !== void 0 && (_viewed$results = viewed.results) !== null && _viewed$results !== void 0 && _viewed$results.length)) {
    return null;
  }

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
    // page__viewed
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_objectSpread(_objectSpread({
      marginBottom: '4rem'
    }, theme.mixins.row()), {}, (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, _lib_consts__WEBPACK_IMPORTED_MODULE_2__/* .DEVICE_SCREENS_MAX_STRING.md */ .fD.md, {
      marginBottom: '2rem'
    })),  true ? "" : 0,  true ? "" : 0),
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
      // page__controls
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_objectSpread(_objectSpread({}, theme.mixins.col(1)), {}, {
        minHeight: 0
      }),  true ? "" : 0,  true ? "" : 0),
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        // main-block-controls-v2
        css: _ref2,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
          // main-block-controls-v2
          css: _ref3,
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
            // main-block-controls-v2__title
            css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
              fontFamily: 'Montserrat',
              fontWeight: '700',
              fontSize: '2.43rem',
              display: 'flex',
              color: theme.colors.black
            }, _lib_consts__WEBPACK_IMPORTED_MODULE_2__/* .DEVICE_SCREENS_MAX_STRING.sm */ .fD.sm, {
              fontSize: '1.8rem'
            }),  true ? "" : 0,  true ? "" : 0),
            children: title
          })
        })
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
      // scroll-wrapper
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        width: '100%'
      }, _lib_consts__WEBPACK_IMPORTED_MODULE_2__/* .DEVICE_SCREENS_MAX_STRING.sm */ .fD.sm, {
        width: '100%',
        overflowX: 'scroll',
        whiteSpace: 'nowrap',
        paddingTop: 7,
        '&>*': {
          whiteSpace: 'normal'
        },
        '::-webkit-scrollbar': {
          display: 'none'
        },
        '-ms-overflow-style': 'none',
        scrollbarWidth: 'none'
      }),  true ? "" : 0,  true ? "" : 0),
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        // actions actions_scroll
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_objectSpread(_objectSpread({}, theme.mixins.flex()), {}, (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, _lib_consts__WEBPACK_IMPORTED_MODULE_2__/* .DEVICE_SCREENS_MAX_STRING.sm */ .fD.sm, {
          flexWrap: 'nowrap'
        })),  true ? "" : 0,  true ? "" : 0),
        children: viewed.results.map(function (item) {
          return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_posts_post_card__WEBPACK_IMPORTED_MODULE_1__/* .PostCard */ .y, {
            item: item,
            currentCity: item.city,
            href: item.url,
            scroll: true
          }, item.id);
        })
      })
    })]
  });
}

/***/ })

}]);